<template>
  <div>
    <v-btn
      rounded
      depressed
      color="primary"
      :loading="loading"
      :class="{ float: $vuetify.breakpoint.smAndDown }"
      @click="doFetch"
    >
      <v-icon v-if="$vuetify.breakpoint.smAndDown">
        mdi-refresh
      </v-icon>
      <span v-else>{{ $t('components.REFRESH') }}</span>

      <v-progress-circular
        v-if="refreshTime"
        :value="percentage"
        :rotate="-90"
        size="14"
        width="2"
        class="ml-1"
      />

      <v-menu>
        <template #activator="{ on }">
          <v-icon
            v-on="on"
            @click.stop
          >
            mdi-menu-down
          </v-icon>
        </template>

        <v-list>
          <v-list-item-group v-model="refreshTime">
            <v-list-item>{{ $t('components.AUTO_REFRESH') }}</v-list-item>
            <v-divider />
            <v-list-item
              v-for="option in refreshOptions"
              :key="`refreshOption:${option.value}`"
              :value="option.value"
            >
              {{ option.text }}
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    fetchData: {
      type: Function,
      default: () => {},
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      refreshTime: null,
      refreshTicker: null,
      refreshTimeCountDown: 0
    };
  },

  computed: {
    refreshOptions() {
      return [
        { text: this.$t('components.REFRESH_NONE'), value: null },
        { text: this.$t('components.REFRESH_SEC_15'), value: 15 },
        { text: this.$t('components.REFRESH_SEC_30'), value: 30 },
        { text: this.$t('components.REFRESH_MIN_1'), value: 60 },
        { text: this.$t('components.REFRESH_MIN_3'), value: 180 }
      ];
    },
    percentage() {
      return Number(
        this.$num.multiply(this.refreshTimeCountDown / this.refreshTime, 100)
      ).toFixed(0);
    }
  },

  watch: {
    refreshTime(v) {
      clearInterval(this.refreshTicker);
      this.refreshTicker = null;
      this.refreshTimeCountDown = v;

      if (v) {
        localStorage.setItem('art', v);
        this.startTicker();
      } else {
        localStorage.removeItem('art');
      }
    }
  },

  mounted() {
    const autoRefreshTime = localStorage.getItem('art');
    this.refreshTime = autoRefreshTime ? Number(autoRefreshTime) : null;

    if (this.refreshTime) {
      this.startTicker();
    }
  },

  beforeDestroy() {
    clearInterval(this.refreshTicker);
    this.refreshTicker = null;
  },

  methods: {
    startTicker() {
      this.refreshTicker = setInterval(() => {
        this.refreshTimeCountDown--;
        if (this.refreshTimeCountDown <= 0) {
          this.refreshTimeCountDown = this.refreshTime;
          this.fetchData();
        }
      }, 1000);
    },
    doFetch() {
      this.fetchData();
      clearInterval(this.refreshTicker);
      this.refreshTicker = null;
      this.refreshTimeCountDown = this.refreshTime;
      if (this.refreshTime) this.startTicker();
    }
  }
};
</script>

<style lang="scss" scoped>
.float {
  /* 預留 App Bar 右側按鈕空間：LanguageSwitcher + UserInfoMeun，保持適當間距 */
  position: fixed;
  right: 136px;
  top: 8px;
  z-index: 99;
}
</style>